__turbopack_context__.v({
  "content": "JPe4Jq_content",
  "contentBottom": "JPe4Jq_contentBottom",
  "contentTop": "JPe4Jq_contentTop",
  "contentWrapper": "JPe4Jq_contentWrapper",
  "link": "JPe4Jq_link",
  "paymentProcessPage": "JPe4Jq_paymentProcessPage",
  "section": "JPe4Jq_section",
  "sectionTitle": "JPe4Jq_sectionTitle",
  "socialIcons": "JPe4Jq_socialIcons",
  "text": "JPe4Jq_text",
  "wrapper": "JPe4Jq_wrapper",
});
